import { Controller } from "react-hook-form";
import { ConnectForm } from "../../providers";
import { CommonInput } from "./CommonInput";
import { ControlledInputProps } from "./CommonInput.types";

export const ControlledInput = ({ name, ...props }: ControlledInputProps) => (
  <ConnectForm>
    {({ control }) => (
      <Controller
        key={name}
        name={name}
        control={control}
        render={({ field: { value, onChange }, formState: { errors } }) => (
          <CommonInput
            errorMessage={errors[name]?.message?.toString()}
            onChange={(event) => onChange(event.target.value)}
            value={value}
            {...props}
          />
        )}
      />
    )}
  </ConnectForm>
);
